import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Country } from '@tradecafe/types/core'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { CountriesService } from 'src/pages/admin/settings/admin-setting-geographic/countries.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createCountry, createCountryFailure, createCountrySuccess, deleteCountry, deleteCountryFailure, deleteCountrySuccess, loadCountries, loadCountriesFailure, loadCountriesSuccess, updateCountry, updateCountryFailure, updateCountrySuccess } from './country.actions'

@Injectable()
export class CountryEffects {
  private actions$ = inject(Actions)
  private countries = inject(CountriesService)
  private toaster = inject(ToasterService)


  loadCountries$ = createEffect(() => this.actions$.pipe(
    ofType(loadCountries),
    switchMap(() =>
      from(this.countries.getCountries()).pipe(
        map(countries => loadCountriesSuccess({ countries: countries.data })),
        catchAndLog(this.toaster, 'Unable to fetch countries', loadCountriesFailure
      )))))

  createCountry$ = createEffect(() => this.actions$.pipe(
    ofType(createCountry),
    tap(() => this.toaster.progress('Creating country...')),
    switchMap(action =>
      from(this.countries.create(action.country as Country)).pipe(
        map(country => createCountrySuccess({ country })),
        catchAndLog(this.toaster, 'Unable to create country', createCountryFailure)))))

  updateCountry$ = createEffect(() => this.actions$.pipe(
    ofType(updateCountry),
    tap(() => this.toaster.progress('Updating country...')),
    switchMap(action =>
      from(this.countries.update({ ...action.country, country_id: action.id })).pipe(
        map(country => updateCountrySuccess({ country })),
        catchAndLog(this.toaster, 'Unable to update country', updateCountryFailure)))))

  deleteCountry$ = createEffect(() => this.actions$.pipe(
    ofType(deleteCountry),
    tap(() => this.toaster.progress('Deleting country...')),
    switchMap(action =>
      from(this.countries.remove({ country_id: action.id })).pipe(
        map(() => deleteCountrySuccess({ id: action.id })),
        tap(() => this.toaster.success('Country deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete country', deleteCountryFailure)))))
}
